import React from "react";

export default function WelcomeAccountSettings() {
  return <div>WelcomeAccountSettings</div>;
}
